module.exports = __webpack_public_path__ + "static/valentin-radulescu.6ee9896d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentin-radulescu.jpg
// module id = 134
// module chunks = 35783957827783 114276838955818